<template>
    <div
        class="dropdown"
        :class="active ? 'open' : 'closed'"
        ref="dropdown"
    >
        <div
            class="dropdown--trigger"
            @click="onToggle"
        >
            <slot name="trigger">
                <button
                    type="button"
                    class="btn btn--primary-inverted btn--full-width dropdown-toggle"
                >
                    {{ triggerLabel }}
                    <span>
                        <Caret />
                    </span>
                </button>
            </slot>
        </div>
        <div
            v-if="active"
            class="dropdown--content"
        >
            <slot name="content">
                <ul
                    class="dropdown-options"
                    :class="contentClass"
                >
                    <slot name="options" />
                </ul>
            </slot>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Caret from '../../icons/Caret.vue';

export default defineComponent({
    name: 'Dropdown',

    components: {
        Caret
    },

    props: {
        value: Boolean,
        disabled: Boolean,
        triggerLabel: { type: String, required: false, default: 'Select an option' },
        contentClass: String
    },

    data() {
        return {
            active: this.value
        }
    },

    emits: ['input'],

    methods: {
        onOpen: function () {
            this.setActiveState(true)
        },

        onClose: function () {
            this.setActiveState(false)
        },

        onToggle: function () {
            this.setActiveState(!this.active)
        },

        setActiveState: function (state) {
            if (this.disabled) return

            this.active = state
        },

        onClickOutside: function (e) {
            if (this.$refs.dropdown !== e.target && !this.$refs.dropdown.contains(e.target)) {
                this.onClose()
            }
        }
    },

    beforeMount: function () {
        document.addEventListener('click', this.onClickOutside)
    },

    destroyed: function () {
        document.removeEventListener('click', this.onClickOutside)
    },

    watch: {
        value: function (active) {
            this.active = active
        },

        active: function (active) {
            this.$emit('input', active)
        }
    }
})
</script>

<style lang="scss">
@import "../../../sass/redesign-2026/new-variables";

.dropdown {
    position: relative;

    &--content {
        position: absolute;
        z-index: 10;
        margin-top: 0.25rem;
        box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba($primary, 0.25);
        border-radius: 0.5rem;
        background-color: #fff;
        width: 100%;
        overflow: hidden;
    }

    button {
        display: flex !important;
        justify-content: space-between;
        align-items: center;

        span {
            .caret-icon path {
                transition: stroke 0.25s;
                fill: none;
            }
        }

        &:hover span .caret-icon path {
            stroke: #fff;
        }
    }
}

.dropdown-toggle {
    text-transform: none;
}

.dropdown-options {
    margin: 0;
    background-color: white;
    padding: 0;

    li {
        display: block;
        padding: 0;

        &.selected {
            background-color: #eee;
            text-decoration: none;
        }

        >a,
        >span {
            display: block;
            padding: 0.5rem 1rem;
            color: $primary;

            &:hover {
                background-color: #eee;
                text-decoration: none;
            }
        }
    }
}
</style>